<template>
  <div class="admin-questions-wrap">
    <main class="page">

      <p class="breadcrumb">SEQ / Admin / Questions</p>

      <div class="page-header">
        <div class="page-header-text">
          <h1 class="page-title">Questions</h1>
          <p class="page-subtitle">
            Question library. Edit existing questions or create new ones.
          </p>
          <p class="page-note">
            <svg class="note-icon" viewBox="0 0 16 16" aria-hidden="true">
              <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.2"/>
              <path d="M8 7v4.5M8 4.5v.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
            </svg>
            To export questions for translation,
            <router-link to="/admin/questionnaires" class="page-note-link">open a questionnaire</router-link>.
          </p>
        </div>
        <button
          type="button"
          class="btn btn-primary new-button"
          @click="showNewDialog = true"
        >
          <svg class="plus-icon" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          New question
        </button>
      </div>

      <QuestionBankBrowser mode="standalone" />

    </main>

    <NewQuestionDialog
      v-if="showNewDialog"
      @cancel="showNewDialog = false"
      @continue="onNewContinue"
    />
  </div>
</template>

<script>
import QuestionBankBrowser from '@/components/admin/QuestionBankBrowser.vue';
import NewQuestionDialog from '@/components/admin/NewQuestionDialog.vue';

export default {
  name: 'AdminQuestionsList',
  components: { QuestionBankBrowser, NewQuestionDialog },
  data() {
    return {
      showNewDialog: false,
    };
  },
  methods: {
    onNewContinue({ question_type }) {
      this.showNewDialog = false;
      this.$router.push({
        path: '/admin/questions/new',
        query: { type: question_type },
      });
    },
  },
};
</script>

<style scoped>
.admin-questions-wrap {
  --color-bg-page: #ffffff;
  --color-bg-card: #ffffff;
  --color-bg-soft: #fafaf7;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.12);
  --color-border-strong: rgba(0, 0, 0, 0.2);
  --color-accent: #534AB7;
  --color-accent-soft: rgba(83, 74, 183, 0.12);
  --color-accent-dark: #3F368F;
  --radius-md: 8px;
  --font-sans: 'Montserrat', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.6;
  min-height: 100%;
  box-sizing: border-box;
}

.admin-questions-wrap *,
.admin-questions-wrap *::before,
.admin-questions-wrap *::after {
  box-sizing: border-box;
}

.page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem 4rem;
}

.breadcrumb {
  font-size: 13px;
  color: var(--color-text-tertiary);
  margin-bottom: 1rem;
  letter-spacing: 0.02em;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.page-header-text {
  flex: 1;
  min-width: 240px;
}

.page-title {
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 0.5rem;
  line-height: 1.2;
}

.page-subtitle {
  font-size: 16px;
  color: var(--color-text-secondary);
  margin: 0;
  font-weight: 400;
}

.page-note {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: var(--color-text-tertiary);
  margin: 6px 0 0;
  line-height: 1.4;
}

.note-icon {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  color: var(--color-text-tertiary);
}

.page-note-link {
  color: var(--color-accent);
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.15s;
}

.page-note-link:hover {
  border-bottom-color: var(--color-accent);
}

.btn {
  padding: 9px 16px;
  border-radius: var(--radius-md);
  font-size: 13px;
  font-family: inherit;
  font-weight: 500;
  cursor: pointer;
  border: 0.5px solid var(--color-border);
  transition: background 0.15s, border-color 0.15s, color 0.15s, opacity 0.15s;
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.btn-primary {
  background: var(--color-accent);
  color: white;
  border-color: var(--color-accent);
}

.btn-primary:hover:not(:disabled) {
  background: var(--color-accent-dark);
  border-color: var(--color-accent-dark);
}

.new-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  margin-top: 4px;
}

.plus-icon {
  width: 13px;
  height: 13px;
}
</style>
